module.exports = __webpack_public_path__ + "img/logo-footer.5332f3ae.svg";